import { useMemo } from 'react';

import { useQueryWithErrorLogging } from '@savvy/graphql-hooks/useQueryWithErrorLogging';

import { ClientPortalOwnTasksQuery } from '../api/own-tasks-query';
import { useClientPortalFundingPhase } from './use-client-portal-funding-phase';

export function useOwnOnboardingTaskIds(): ReadonlySet<string> {
  const { phase } = useClientPortalFundingPhase();
  const awaitingAccountOpening = phase === 'AWAITING_ACCOUNT_OPENING';

  const { data } = useQueryWithErrorLogging(ClientPortalOwnTasksQuery, { skip: !awaitingAccountOpening });

  return useMemo(
    () => new Set(awaitingAccountOpening ? (data?.tasks.map((task) => task.id) ?? []) : []),
    [awaitingAccountOpening, data],
  );
}
